const skills = ['Java','Python','MySQL','Arduino','Android','Git','LabView','Vue','React','React native','Flask','Fast API']

function SkillList() {
	const listItems = skills.map((skill, index) =>
	  <li index={index}>{skill}</li>
	);
	return listItems;
  }
  
  function Presentation() {
	  return (
		  <section id="presentationContainer">	
			<div className="Presentation">
				<div className="myself">
					<h1>DAVID <br/>HOSTALRICH <br/>JATO </h1>
					<p>Ingeniero en telecomunicaciones y actualmente programador. Desde siempre me ha interesado la programación, y ahora que tengo la oportunidad estoy intentando crecer todo lo que pueda en este sector de forma autodidacta, con muchas ganas de trabajar en un equipo profesional. <br/><br/>En este portfolio mostraré tanto mis estudios y experiencia laboral como los proyectos que he sacado adelante por cuenta propia.</p>
				</div>
				
				<div className="skills">
					<h2>CONOCIMIENTOS</h2>
					<ul className="skillList">{SkillList()}</ul>
				</div>
			</div>
		</section>
	);

}

export default Presentation;